import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type HttpParamValue = string | number | boolean;
export interface HttpParamsObject {
  [param: string]: HttpParamValue | ReadonlyArray<HttpParamValue>;
}
@Injectable({ providedIn: 'root' })
export class APIService {
  constructor(private http: HttpClient) {}

  /**
   * Recive data from resource.
   *
   * @param url the api url = resource.
   * @param paramsObject optional param to pass data to request
   * @return response of request = data
   */
  public callGetAPI<T>(
    url: string,
    paramsObject?: HttpParamsObject,
    header?: {},
    responseType: any = 'json',
    context?: HttpContext,
  ): Observable<T> {
    const params = paramsObject && this.getHttpParams(paramsObject);
    const headers = header;
    return this.http.get<T>(url, { params, headers, responseType, context });
  }

  /**
   * Send data to server and update/create resource.
   *
   * @param url the api url = resource.
   * @param data data that gets passed to resource
   * @return response of request (data or status)
   */
  public callPostAPI<T>(
    url: string,
    data: any | null,
    responseType: any = 'json',
    header?,
  ): Observable<T> {
    const headers = header;
    return this.http.post<T>(url, data, { headers, responseType });
  }

  /**
   * Delete the resource.
   *
   * @param url the api url = resource.
   * @return response of request (status)
   */
  public callDeleteAPI(url: string, params?): Observable<any> {
    return this.http.delete(url, { params });
  }

  /**
   * Update the resource.
   *
   * @param url the api url = resource.
   * @param data optional data to be updated
   * @param paramsObject optional param for request (e.g language, amount,..)
   * @return response of request
   */
  public callPutAPI<T>(
    url: string,
    data?: any | null,
    paramsObject?: HttpParamsObject,
    headers?,
  ): Observable<T> {
    const params = paramsObject && this.getHttpParams(paramsObject);
    return this.http.put<T>(url, data, { params, headers });
  }

  /**
   * Get HTTP Params.
   *
   * @param paramsObject optional object of params.
   * @return HTTP params
   */
  private getHttpParams(paramsObject?: HttpParamsObject): HttpParams {
    let params: HttpParams = new HttpParams();

    if (paramsObject) {
      Object.keys(paramsObject).forEach((key) => {
        if (Array.isArray(paramsObject[key])) {
          (paramsObject[key] as HttpParamValue[]).forEach((value) => {
            params = params.has(key)
              ? params.append(key, value)
              : params.set(key, value);
          });
        } else {
          const value = paramsObject[key] as HttpParamValue;
          params = params.set(key, value);
        }
      });
    }
    return params;
  }
}
